
import * as vercelRuntime$b8uWPRx1qM from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "vercel",
  "domains": [
    "bydesignhomes-alpha-files.neuronwebsites.com",
    "files.bydesignhomes.neuronwebsites.co.uk",
    "files.brownsestateagents.neuronwebsites.co.uk",
    "files.neilking.neuronwebsites.co.uk",
    "files.allenresidential.neuronwebsites.co.uk",
    "files.greyandco.neuronwebsites.co.uk",
    "files.no86estateagency.neuronwebsites.co.uk",
    "files.priceestateagents.neuronwebsites.co.uk",
    "files.keysandlee.neuronwebsites.co.uk",
    "files.icebergdigital.neuronwebsites.co.uk",
    "files.estateagencyx.neuronwebsites.co.uk",
    "files.copeandco.neuronwebsites.co.uk",
    "files.markburgess.neuronwebsites.co.uk",
    "files.roderickthomas.neuronwebsites.co.uk",
    "files.rochfordstokes.neuronwebsites.co.uk"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ]
}

imageOptions.providers = {
  ['vercel']: { provider: vercelRuntime$b8uWPRx1qM, defaults: {} }
}
        